import { ApiClient } from '../api-client';

const MemberhubApi = ApiClient.service.memberhub;

const useMemberhubApi = () => {
  return MemberhubApi;
};

export { MemberhubApi, useMemberhubApi };
